import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {WebNavigationService} from '../../navigation.service';

@Component({
  selector: 'app-transfer-option',
  templateUrl: 'transfer-option.component.html',
  styleUrls: ['transfer-option.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class TransferOptionComponent implements OnInit {

  constructor(private navigationService: WebNavigationService) {
  }

  ngOnInit() {
  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }

  get expandTransfers() {
    return this.navigationService.expandTransfers;
  }

  selectOption(option) {
    this.navigationService.selectOption(option);
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/transfers/transfer-option.component.ts